module.exports = __webpack_public_path__ + "img/5f_r_iso.38b35ae1.jpg";